var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoblack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 38,
    viewBox: "0 0 92 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.92026 24.3735L24.9822 -0.00230078L30.9024 12.9884L11.8405 37.3643L5.92026 24.3735Z",
    fill: "#060A23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0797 24.3735L67.0178 -0.00230078L61.0976 12.9884L80.1595 37.3643L86.0797 24.3735Z",
    fill: "#060A23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9124 24.3735L49.9744 -0.00230078L55.8946 12.9884L36.8327 37.3643L30.9124 24.3735Z",
    fill: "#060A23"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 37.3666,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoblack);
export default __webpack_public_path__ + "static/media/logoblack.239997d2514593b5d14127342997d916.svg";
export { ForwardRef as ReactComponent };